import React, { useCallback, useEffect, useState } from 'react';
import styles from './category.module.scss';
import {
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoSelect,
  KoText,
  KoTextArea,
  Upload
} from 'packages';
import ImgCrop from 'antd-img-crop';
import KoIcon from '@kwapio/icons';
import { getCookie } from 'shared/utils/cookies';
import { OrdersAPI } from '../../../orders.service';

export default function SubCategoryForm({ form,handleFinish, onCategoryChange
}) {
  const [uploadLoading, setUploadLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);

  useEffect(() => {
    OrdersAPI.getCategory()
      .then((res) => {
        setCategoryList(Array.isArray(res?.categories) ? res.categories : []);
      })
      .catch(() => setCategoryList([]));
  }, []);

  const Category = ({ value, onChange }) => (
    <KoSelect
      value={value}
      showSearch
      optionFilterProp="label"
      placeholder="Select Category"
      onChange={(val) => {
        onChange(val);
        onCategoryChange(val);
      }}
      options={categoryList.map((cat) => ({
        label: cat?.name || 'Unnamed Category',
        value: cat?.categoryId
      }))}
    />
  );

  const TextArea = ({ value, onChange }) => (
    <KoTextArea value={value} onChange={onChange} showCount maxLength={100} />
  );

  const meta = {
    columns: 4,
    colon: true,
    fields: [
      {
        key: 'name',
        label: 'Sub Category Name',
        colSpan: 4,
        rules: [{ required: true, message: 'Subcategory name is required' }]
      },
      {
        key: 'categoryId',
        label: 'Category',
        colSpan: 4,
        widget: Category,
        rules: [{ required: true, message: 'Category is required' }]
      },
      {
        key: 'description',
        label: 'Description',
        colSpan: 4,
        widget: TextArea
      }
    ]
  };

  const normFile = useCallback((e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList || [];
  }, []);

  const uploadProps = {
    name: 'files',
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    headers: {
      Authorization: `Bearer ${getCookie('accessToken')}`
    },
    onChange(info) {
      if (info.file.status === 'uploading') {
        setUploadLoading(true);
      }
      if (info.file.status === 'done' || info.file.status === 'error') {
        setUploadLoading(false);
      }
    }
  };

  return (
    <div className={styles.formWrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleFinish}>

        <KoForm.Item
          name="logo"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <ImgCrop aspect={115 / 25}>
            <Upload
              {...uploadProps}
              listType="picture-card"
              showUploadList={false}
            >
              <div className={styles.dndArea}>
                {uploadLoading && <KoLoader size="small" />}
                <KoIcon name="ImagesOutlined" width={40} height={40} />
                <KoText text="Upload Image" />
              </div>
            </Upload>
          </ImgCrop>
        </KoForm.Item>

        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
}
